export const ARTICLE_PUBLISH = "publishArticle";
export const ARTICLE_DELETE = "deleteArticle";
export const ARTICLE_EDIT = "editArticle";
export const ARTICLE_EDIT_ADD_TAG = "addTagToArticle";
export const ARTICLE_EDIT_REMOVE_TAG = "removeTagFromArticle";
export const ARTICLE_RESET_STATE = "resetArticleState";
export const CHECK_AUTH = "checkAuth";
export const COMMENT_CREATE = "createComment";
export const COMMENT_DESTROY = "destroyComment";
export const FAVORITE_ADD = "addFavorite";
export const FAVORITE_REMOVE = "removeFavorite";
export const FETCH_ARTICLE = "fetchArticle";
export const FETCH_ARTICLES = "fetchArticles";
export const FETCH_COMMENTS = "fetchComments";
export const FETCH_PROFILE = "fetchProfile";
export const FETCH_PROFILE_FOLLOW = "fetchProfileFollow";
export const FETCH_PROFILE_UNFOLLOW = "fetchProfileUnfollow";
export const FETCH_TAGS = "fetchTags";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const REGISTER_SET_FORM = "registerSetForm";
export const REGISTER_RESET_FORM = "registerResetForm";
export const PROFILE_SET_FORM = "profileSetForm";
export const PRODUCT_SET_FORM = "productSetForm";
export const PRODUCT_ADD_CART_SET_FORM = "productAddCartSetForm";
export const PRODUCT_EDIT_CART_SET_FORM = "productEditCartSetForm";
export const PRODUCT_DELETE_CART_SET_FORM = "productDeleteCartSetForm";
export const ADD_FAVORITE_FORM = "setFavoreteAddForm";
export const DELETE_FAVORITE_FORM = "setFavoreteEditForm";
export const ADD_USER_FORM = "addUserForm";
export const QUANTITY_CART_SET_FORM = "setQuantityCartForm";
export const TOTAL_CART_SET_FORM = "setTotalCartForm";
export const USER_ORDER_SET_FORM = "setUserOrderForm";
export const UPDATE_USER_ORDER_SET_FORM = "setUpdateUserOrderForm";
export const UPDATE_ARRIVAL_DATE_ORDER_SET_FORM =
  "setUpdateArrivalDateOrderForm";
export const ITEM_ORDER_SET_FORM = "setItemOrderForm";
export const UPDATE_DISCOUNT_ORDER_SET_FORM = "setDiscountOrderForm";
export const COMBINI_ORDER_SET_FORM = "COMBINI_ORDER_SET_FORM";
export const CARD_ORDER_SET_FORM = "CARD_ORDER_SET_FORM";
export const PAYMENT_ORDER_SET_FORM = "PAYMENT_ORDER_SET_FORM";
export const PRODUCT_DETAIL_SET = "PRODUCT_DETAIL_SET";
export const FORGOT_SET_FORM = "FORGOT_SET_FORM";
export const GET_LIST_FAVORITE = "GET_LIST_FAVORITE";
export const ADD_CART = "ADD_CART";
export const GET_CART = "GET_CART";
export const UPDATE_CART = "UPDATE_CART";
export const ADD_LOCAL_CART = "ADD_LOCAL_CART";
export const ADD_NEW_LOCAL_CART = "ADD_NEW_LOCAL_CART";
export const CHECK_PRODUCT_LOCAL_CART = "CHECK_PRODUCT_LOCAL_CART";
export const CHECK_CART = "CHECK_CART";
export const CHECH_PRODUCT_CART = "CHECH_PRODUCT_CART";
export const DELETE_ITEM_CART_LOCAL = "DELETE_ITEM_CART_LOCAL";
export const RESET_CART = "RESET_CART";
export const UPDATE_ITEM_CART_LOCAL = "UPDATE_ITEM_CART_LOCAL";
export const GET_CART_LOCAL = "GET_CART_LOCAL";
export const GET_CART_LOCAL_API = "GET_CART_LOCAL_API";
export const MERGE_CART = "MERGE_CART";
export const SET_CART_FORM = "SET_CART_FORM";
export const ORDER_SET_FORM = "ORDER_SET_FORM";
export const GET_PRODUCT_OPTION1 = "GET_PRODUCT_OPTION1";
export const GET_PRODUCT_OPTION2 = "GET_PRODUCT_OPTION2";
export const GET_CATEGORY_PRODUCT = "GET_CATEGORY_PRODUCT";
export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const GET_ORDER_LIST = "GET_ORDER_LIST";
export const PURCHASE_AUTHORITY_CHECK = "PURCHASE_AUTHORITY_CHECK";
export const PLACE_ORDER = "PLACE_ORDER";
export const AUTH_PLACE_ORDER = "AUTH_PLACE_ORDER";
export const PLACE_ORDER_PAYPAY = "PLACE_ORDER_PAYPAY";
export const AUTH_PLACE_ORDER_PAYPAY = "AUTH_PLACE_ORDER_PAYPAY";
export const CONFIRM_WITHDRAWAL = "CONFIRM_WITHDRAWAL";
export const GET_ORDER = "GET_ORDER";
export const PROFILE_INIT = "PROFILE_INIT";
export const REGISTER_SET_ADDRESS = "REGISTER_SET_ADDRESS";
export const PROFILE_SET_ADDRESS = "PROFILE_SET_ADDRESS";
export const CLEAR_CART_ACTION = "CLEAR_CART_ACTION";
export const FORGOT = "FORGOT";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const GET_NEW_PRODUCT = "GET_NEW_PRODUCT";
export const GET_PRODUCTS_BY_TAG_ID = "GET_PRODUCTS_BY_TAG_ID";
export const GET_LIST_GOODS = "GET_LIST_GOODS";
export const GET_GOOD_DETAIL = "GET_GOOD_DETAIL";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_ALL_GOODS = "GET_ALL_GOODS";
export const CREATE_CREDIT_CARD = "CREATE_CREDIT_CARD";
export const PUBLIC_ORDER = "PUBLIC_ORDER";
export const AUTH_PUBLIC_ORDER = "AUTH_PUBLIC_ORDER";
export const AUTH_PUBLIC_WITH_CUS_ORDER = "AUTH_PUBLIC_WITH_CUS_ORDER";
export const ADDRESS_ZIPCODE = "ADDRESS_ZIPCODE";
export const ORDER_ZIPCODE = "ORDER_ZIPCODE";
export const RESET_ORDER_FORM = "RESET_ORDER_FORM";
export const AUTH_UPDATE_CARD = "AUTH_UPDATE_CARD";
export const ORDER_CHANGE_DELIVERY_ADDRESS = "ORDER_CHANGE_DELIVERY_ADDRESS";
export const ORDER_WITHOUT_CARD_REGISTER = "ORDER_WITHOUT_CARD_REGISTER";
export const GET_SHIPPING_NOODLE = "GET_SHIPPING_NOODLE";
export const GET_SHIPPING_GOODS = "GET_SHIPPING_GOODS";
export const UPDATE_QUANTITY_NOODLES = "UPDATE_QUANTITY_NOODLES";
export const UPDATE_QUANTITY_GOODS = "UPDATE_QUANTITY_GOODS";
export const UPDATE_SIZE_NOODLES_LOCAL = "UPDATE_SIZE_NOODLES_LOCAL";
export const UPDATE_SIZE_GOODS_LOCAL = "UPDATE_SIZE_GOODS_LOCAL";
export const CONVENIENCE_STORES_CUS_ORDER = "CONVENIENCE_STORES_CUS_ORDER";
export const CLEAR_ERROR_ORDER = "CLEAR_ERROR_ORDER";
export const GET_PREFECTURE = "GET_PREFECTURE";
export const RESET_CODE_CONVENIENCE_STORES_ORDER =
  "RESET_CODE_CONVENIENCE_STORES_ORDER";
export const UPDATE_OPTION_ITEM_CART_LOCAL = "UPDATE_OPTION_ITEM_CART_LOCAL";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const VALIDATE_COUPON = "VALIDATE_COUPON";
export const CLEAR_COUPON = "CLEAR_COUPON";
export const CLEAR_SHIPPING_NOODLE = "CLEAR_SHIPPING_NOODLE";
export const CLEAR_SHIPPING_GOODS = "CLEAR_SHIPPING_GOODS";
export const GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME =
  "GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME";
export const GET_PRODUCTS_BY_PUBLIC_TAGS_NAME =
  "GET_PRODUCTS_BY_PUBLIC_TAGS_NAME";
export const RESET_ERROR_AUTH = "SET_ERROR_AUTH";
export const GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME_WITH_SORT =
  "GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME_WITH_SORT";
export const GET_PRODUCTS_BY_PUBLIC_TAGS_NAME_WITH_SORT =
  "GET_PRODUCTS_BY_PUBLIC_TAGS_NAME_WITH_SORT";
export const GET_ORDER_PRICE = "GET_ORDER_PRICE";
export const SET_ORDER_PRICE_PAYLOAD_ACTION = "SET_ORDER_PRICE_PAYLOAD_ACTION";
export const GET_COMPANY_PURCHASE_LIMIT_PER_DAY =
  "GET_COMPANY_PURCHASE_LIMIT_PER_DAY";
export const GET_RECENT_NEWS_LIST = "GET_RECENT_NEWS_LIST";
export const VALIDATE_EMAIL = "VALIDATE_EMAIL";
export const SET_TOKEN = "SET_TOKEN";
export const REGISTER_WITH_TOKEN = "REGISTER_WITH_TOKEN";
export const AUTH_PLACE_ORDER_CREATE_CARD_VERITRANS =
  "AUTH_PLACE_ORDER_CREATE_CARD_VERITRANS";
export const AUTH_PLACE_ORDER_UPDATE_CARD_VERITRANS =
  "AUTH_PLACE_ORDER_UPDATE_CARD_VERITRANS";
export const AUTH_PLACE_ORDER_VERITRANS = "AUTH_PLACE_ORDER_VERITRANS";
export const AUTH_TDS_ORDER_CONFIRM = "AUTH_TDS_ORDER_CONFIRM";
export const AUTH_TDS_ORDER_CARD_CONFIRM = "AUTH_TDS_ORDER_CARD_CONFIRM";
export const PLACE_ORDER_VERITRANS = "PLACE_ORDER_VERITRANS";
export const TDS_ORDER_CONFIRM = "TDS_ORDER_CONFIRM";
